export var OriginalAmountAssetType;
(function (OriginalAmountAssetType) {
    OriginalAmountAssetType["SOURCE"] = "SOURCE";
    OriginalAmountAssetType["DESTINATION"] = "DESTINATION";
})(OriginalAmountAssetType || (OriginalAmountAssetType = {}));
//# sourceMappingURL=original-amount-asset-type.enum.js.map